import MultiplePanel from './MultiplePanel';

export default MultiplePanel;
